import React, {useEffect, useState} from 'react'
// Styles
import formStyles from './forms.module.scss'

interface InputTextareaProps {
  id: string
  label: string
  instructions?: React.ReactNode
  placeholder?: string
  initialValue?: string
  errorMessage?: string | null
  isSmall?: boolean
  isWhite?: boolean
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement> | { target: { value: string } }) => void
  characterLimit?: number | null
}

const InputTextarea = ({
  id,
  label,
  instructions,
  placeholder,
  initialValue = '',
  errorMessage = null,
  isSmall = false,
  isWhite = false,
  onChange,
  characterLimit = null,
}: InputTextareaProps) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  const handleChange = (syntheticEvent: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = syntheticEvent.target.value

    if (characterLimit && newValue.length > characterLimit) {
      setValue(newValue.slice(0, characterLimit))

      const modifiedEvent = {
        ...syntheticEvent,
        target: {
          ...syntheticEvent.target,
          value: newValue.slice(0, characterLimit),
        },
      }

      if (onChange) onChange(modifiedEvent)
    } else {
      setValue(newValue)
      if (onChange) onChange(syntheticEvent)
    }
  }
  return (
    <div
      key={`field-${id}`}
      className={formStyles['__textarea-wrapper']}
    >
      <label className={formStyles['__label']}>{label}</label>
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        autoComplete="off"
        rows={3}
        className={`${formStyles['__field']} ${isSmall && formStyles['--is-small']} ${isWhite && formStyles['--is-white']}`}
      ></textarea>
      {errorMessage && (
        <span className={formStyles['__error-message']}>
          {errorMessage}
        </span>
      )}
      <div className={formStyles['__instructions']}>
        {instructions}
        {characterLimit && (
          <span className={formStyles['__character-limit']}>
            &nbsp;Character Limit: {value.length}/{characterLimit}
          </span>
        )}
      </div>
    </div>
  )
}

export default InputTextarea
